import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import { update_MeasurementSettingDetails_forEdit } from "./../../slice/orderSlice";

// function CustomerAdd(props, ref) {
const MeasurementAttributeAdd = React.forwardRef((props, ref) => {
  //Get state from store
  const { measurementSettingDetailForEdit } = useSelector(
    (state) => state.order
  );

  // const dropdownOptions = [
  //   { key: "Select your course", value: "" },
  //   { key: "React", value: "react" },
  //   { key: "Angular", value: "angular" },
  //   { key: "Vue", value: "vue" },
  // ];

  // const checkboxOptions = [
  //   { key: "HTML", value: "html" },
  //   { key: "CSS", value: "css" },
  //   { key: "JavaScript", value: "javascript" },
  // ];

  const initialValues = {
    FieldName: measurementSettingDetailForEdit
      ? ""
      : measurementSettingDetailForEdit?.fieldName,
    RowNo: measurementSettingDetailForEdit
      ? ""
      : measurementSettingDetailForEdit?.rowNo,
    ColumnNo: measurementSettingDetailForEdit
      ? ""
      : measurementSettingDetailForEdit?.columnNo,
    FieldType: measurementSettingDetailForEdit
      ? false
      : measurementSettingDetailForEdit?.fieldType,
  };

  const validationSchema = Yup.object({
    fieldName: Yup.string().required("Required"),
    rowNo: Yup.string().required("Required"),
    columnNo: Yup.string().required("Required"), // .email("Invalid email format"),

    // bio: Yup.string().required("Required"),
    // course: Yup.string().required("Required"),
    // courseDate: Yup.date().required("Required").nullable(),
  });

  const onSubmit = async (values) => {
    console.log("Form data", values);
    alert("add customer submit:: " + values.orderOfShow);
    props.AddMeasurementToDB(values);
  };

  // const onSubmit = (event) => {
  //   alert("Form submitted");
  //   event.preventDefault();
  //   //Your code here. For example,
  // };

  //********************* Form validation send to Parent form */
  React.useEffect(() => {
    // Update the document title using the browser API
    // alert("document.getElementById(submitButton).disabled");
    props.isValidChildFormInputs(
      document.getElementById("submitButton")?.disabled
    );
  }, [document.getElementById("submitButton")?.disabled]);

  return (
    <>
      {measurementSettingDetailForEdit?.fieldName}

      <Formik
        initialValues={measurementSettingDetailForEdit}
        // validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              {/* <FormikControl
              control="input"
              type="text"
              label="MeasurementSettingsDetailsID_GUID"
              name="MeasurementSettingsDetailsID_GUID"
            /> */}
              {/* MeasurementSettingsID_GUID */}
              {/* IsNote */}
              {/* FieldType */}
              <FormikControl
                control="input"
                type="text"
                label="Attribute Name"
                name="fieldName"
              />
              <FormikControl
                control="input"
                type="text"
                label="Row No"
                name="rowNo"
              />
              <FormikControl
                control="input"
                type="text"
                label="Column No"
                name="columnNo"
              />

              <FormikControl
                control="input"
                type="text"
                label="Order Of Show"
                name="orderOfShow"
              />

              <FormikControl
                control="input"
                type="checkbox"
                label="Is Check Box"
                name="fieldType"
              />

              <button
                id="submitButton"
                type="submit"
                disabled={
                  !formik.isValid || !formik.dirty || formik.isSubmitting
                }
                ref={ref}
              >
                Submit
              </button>
            </Form>
          );
        }}
      </Formik>
    </>
  );
});

export default MeasurementAttributeAdd;
